<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="copy-outline" pack="eva"></nb-icon>
  <div class="description">
    <div class="title">
      {{buildingSection?.sectionText}}
    </div>
    <div class="subtitle" *ngIf="building() as building">{{building.internalNumber}} / {{building.allocationData.ownerTenant.name}} / {{building.baseData.area | number: '1.2-2'}} m²</div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>

